export default {
  routings: [],
  users: [],
  requestStatus: 'loading',
  activeRouting: null,
  activeUser: null,
  breadcrumbs: [],
};
